<template>
  <li class="breadcrumb-item" :class="{active: active}">
    <slot></slot>
  </li>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'breadcrumb-item',

  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
});
</script>
<style>
</style>
